export default __webpack_public_path__ + "static/media/inner-logo.0222ec61.svg";